module.exports = __webpack_public_path__ + "img/robot.149601a2.png";